<template>
  <div class="asideFixed">
    <div class="item item1" :class="itemShow == 'item1' ? 'on' : ''" @mouseleave="itemMouseLeave" @mouseover="itemMouseOver('item1')">
      <div class="bg">
        <div class="box asideKF">
          <dl>
            <dt style="margin-bottom:6px;">客户经理</dt>
            <dd class="J_service_replace">
              <template v-for="(item, index) in vipList">
                <template v-if="index != vipList.length -1">
                  <div style="padding-bottom:6px;" v-if="item.service_name != '' && item.service_phone != ''">{{ item.service_name }}: {{ item.service_phone }}</div>
                </template>
                <div style="padding-bottom:6px;" v-else>
                  <p>在线客服：<a style="color:#00FF94;" href="https://www.hqchip.com/ajax/dezhu?token=6nu6RbIFfQNf&showChat=true&layout=true" target="_blank">立即咨询</a> </p>
                  <p class="g-mt5"><i class="iconfont">&#xe68e;</i>{{ item.service_phone }}</p>
                </div>
              </template>
            </dd>
            <dt>工作时间</dt>
            <dd>
              <p class="g-mt10">周一至周五（9:00-12:00 13:30-18:30）节假日除外</p>
              <p class="g-mt5 g-mb20">投诉电话：<span class="J_complain">{{ servicePhone }}</span></p>
            </dd>
          </dl>
          <div class="delta"></div>
        </div>
      </div>
    </div>
    <div class="item item8" v-if="isShowWx" :class="itemShow == 'item8' ? 'on' : ''" @mouseleave="itemMouseLeave" @mouseover="itemMouseOver('item8')">
      <div class="bg">
        <div class="box asideWX">
          <p class="tit">扫描微信二维码咨询客服</p>
          <img :src="wxImg" style="margin: 10px auto;display: block;">
          <p class="g-tc" style="border-top: 1px dotted #bbb;padding-top:10px;"></p>
          <select v-model="wxImg" @change="handleChangeWx">
            <option v-for="item in wxList" :value="item.service_wechat">{{ item.service_name }}</option>
          </select>
          <div class="delta"></div>
          <dt class="g-mt10 tit">工作时间</dt>
          <dd>
            <p class="g-mt10">周一至周五：（09:00-12:00</p>
            <p><span>13:30-18:30）节假日除外</span></p>
            <p class="g-mt5 g-mb20">投诉电话：<span class="J_complain">{{ servicePhone }}</span></p>
          </dd>
        </div>
      </div>
    </div>
    <div class="item item5" :class="itemShow == 'item5' ? 'on' : ''" @mouseleave="itemMouseLeave" @mouseover="itemMouseOver('item5')">
      <div class="bg">
        <div class="box asideWX">
          <p class="tit">微信公众平台</p>
          <img src="@/assets/common/asideFixed/hq_weixin.gif">
          <p class="g-tc g-mb10">搜索：hqchip001</p>
          <p class="g-tc" style="border-top: 1px dotted #bbb;padding-top:10px;"><span style="display:inline-block;"><i class="iconfont g-mr5">&#xe656;</i>型号搜索<span class="g-ml10">订单查询</span></span></p>
          <div class="delta"></div>
        </div>
      </div>
    </div>
    <div class="item item6" :class="itemShow == 'item6' ? 'on' : ''" @mouseleave="itemMouseLeave" @mouseover="itemMouseOver('item6')" @click="handleFeed">
      <div class="bg">
        <div class="box asideHQ">
          反馈建议
          <div class="delta"></div>
        </div>
      </div>
    </div>
    <FeedDialog ref="FeedDialogRef"/>
  </div>
</template>
<script>
import { getcustomerinfo } from '@/api/index.js'
import FeedDialog from './FeedDialog'

export default {
  components: {
    FeedDialog
  },
  data() {
    return {
      itemShow: '',
      isShowWx: true,
      servicePhone: '',
      vipList: [],
      wxList: [],
      wxImg: ''
    }
  },
  methods: {
    itemMouseLeave() {
      this.itemShow = ''
    },
    itemMouseOver(item) {
      this.itemShow = item
    },
    handleChangeWx(e) {
      this.wxImg = e.target.value
    },
    handleFeed() {
      this.$refs['FeedDialogRef'].showFeedDialog()
    }
  },
  mounted() {
    getcustomerinfo({})
      .then(res => {
        if (res.error_code == 0) {
          // TODO 可能需要处理下神策
          // 其他数据判断
          this.vipList = res.data.service.list.reverse()
          const wxList = []
          this.vipList.map(item => {
            if (item.service_wechat) {
              wxList.push(item)
            }
          })
          if (wxList.length > 0) {
            this.wxList = wxList
            this.wxImg = wxList[0].service_wechat
          }
          // 是否展示客服微信
          if (!res.data.service.wechat_show) {
            this.isShowWx = false
          }

          // 投诉电话
          const complain = res.data.service.complain
          if (complain && complain.service_phone) {
            this.servicePhone = complain.service_phone
          }
        }
      })
  }
}
</script>
<style lang="scss" scoped>
.asideFixed{
  position: fixed;
  right: -15px;
  z-index: 999;
  color: #fff;
  padding-bottom: 63px;
  top: 50%;
  transform: translateY(-50%);
}
.asideFixed .myorder:hover {
	background-color:  #B60005;
}
.asideFixed .addTips {
	color: #000;
	font-weight: bold;
	font-size: 18px;
	position: absolute;
	top: -60px;
	right: 46px;
	animation: myfirst 1s ease 0s 1 normal both;
}
@-webkit-keyframes myfirst 
{
    0% {
			opacity: 1;
			transform: translateY(0);
		}
    100% {
			opacity: 0;
			transform: translateY(40px);
		}
}
@keyframes navhdimove{
    0% {
        transform: translateY(0px);
        /*开始为原始大小*/
    }
    25% {
        transform: translateY(4px);
        /*放大1.1倍*/
    }

    50% {
        transform: translateY(-2px);
    }

    75% {
        transform: translateY(4px);
    }
    100%{
        transform: translateY(0);
    }
}
.asideFixed .item{
	position: relative;
	width: 45px;
	height: 45px;
	cursor: pointer;
	background-image: url('~@/assets/common/asideFixed/aside-fixed-icons.png');
	margin-bottom: 0;
	overflow: hidden;
  right: 15px;
  &.on {
    .bg {
      animation: bganimation 0.3s linear 0s 1 normal both;
      transition: 0.3 all;
      opacity: 1;
      right: 43px;
    }
  }
}
@keyframes bganimation 
{
    0% {
			opacity: 0;
			right: 100px;
		}
    100% {
			opacity: 1;
			right: 43px;
		}
}
.asideFixed .item1 {
	height: 50px;
    background-position: -49px -5px;
}
.asideFixed .item1:hover {
	background-position: -5px -5px;
}
.asideFixed .item2 {
	background-position: -58px -75px;
}
.asideFixed .item2:hover {
	background-position: 0 -75px;
}
.asideFixed .item3 {
	background-position: -49px -133px;
}
.asideFixed .item3:hover {
	background-position: 0 -133px;
}
.asideFixed .item4 {
	background-position: -49px -191px;
}
.asideFixed .item4:hover {
	background-position: 0 -191px;
}
.asideFixed .item5 {
	background-position: -49px -100px;
}
.asideFixed .item5:hover {
    background-position: -5px -100px;
}
.asideFixed .item6 {
	background-position: -49px -145px;
}
.asideFixed .item6:hover {
    background-position: -5px -145px;
}
.asideFixed .item7 {
	display: none;
	position: absolute;
	left: 0;
	bottom: 0;
	background-position: -49px -365px;
}
.asideFixed .item7:hover {
	background-position: 0 -365px;
}
.asideFixed .item8 {
	background-position: -49px -55px;
}
.asideFixed .item8:hover {
    background-position: -5px -55px;
}
.asideFixed .item9 {
	display: none;
	background: url('/Static/img/assign/new_user_coupon.png?v2') center center no-repeat;
}

.asideFixed a{
	color: #fff;
}

.asideFixed .on{
	overflow: visible;
}
.asideFixed .bg {
	position: absolute;
	top: 10px;
	right: 100px;
	padding-right: 35px;
	opacity: 0;
}
.asideFixed .box{
	position: relative;
	background-color: #494949;
	text-align: left;
	line-height: normal;
	border-radius: 4px;
}
.asideFixed .on .box{
	/* display: block; */
}
.asideFixed .delta{
	position: absolute;
	top: 14px;
	right: -12px;
	width: 0px;
	height: 0px;
	border: 6px solid;
	font-size: 0;
	border-color:transparent transparent transparent #494949;
	border-style:dashed dashed dashed solid;
}
.asideFixed .asideHQ{
	width: 80px;
	height: 40px;
	line-height: 40px;
	text-align: center;
}
.asideFixed .asideKF {
	width: 152px;
	padding: 0 12px;
	cursor: auto;
}
.asideKF dt {
	/* padding-bottom: 5px; */
	border-bottom: 1px dotted #a4a4a4;
	font-size: 14px;
	color: #bbb;
	line-height: 32px;
	/* font-weight: 700; */
}
.asideKF dd{
	overflow: hidden;
}
.asideKF img{
	margin-right: 3px;
	width: 14px;
	vertical-align: -2px;
}
.asideKF .service-tel-split {
	padding: 6px 0;
	border-top: 1px dotted #5c5c5c;
}
.asideKF .service-tel-split:first-child {
	border-top: none;
}
.asideKF .service-tel-split .iconfont {
	margin-right: 5px;
}
.asideFixed .asideGWC {
	width: 140px;
	padding: 10px 10px;
	line-height: 20px;
	cursor: auto;
}
.asideGWC dt {
	padding-bottom: 5px;
	border-bottom: 1px dotted #a4a4a4;
	font-size: 14px;
	color: #bbb;
	/* font-weight: 700; */
}
.asideGWC dd {
	padding: 10px 8px;
}
.asideFixed .asideWX{
	top: -41px;
	padding: 10px;
	cursor: auto;
}
.asideWX .tit{
	padding-bottom: 5px;
	border-bottom: 1px dotted #a4a4a4;
	font-size: 14px;
	color: #bbb;
}
.asideWX p{
	white-space: nowrap;
}
.asideWX img{
	margin: 10px auto;
	width: 130px;
}
.asideWX .delta{
	top: 55px;
}
.g-mt5 {
	margin-top: 5px;
}
.g-mr5 {
	margin-right: 5px;
}
.g-mt10 {
	margin-top: 10px;
}
.g-mb10 {
	margin-bottom: 10px;
}
.g-mb20 {
	margin-bottom: 20px;
}
.g-tc {
	text-align: center;
}
</style>